<template>

<div>
    <section class="row">
        <label for="entity_slug" class="col-md-4 col-form-label">Administrative Unit:
        </label>
        <span class="font-weight-bold alert alert-info">{{ this.selectedCodePlusName }} 
            &nbsp<button @click="clear" type="button" class="close" aria-label="Close">
                <span aria-hidden="true"></span>
            </button>
        </span>
    </section>

    <section class="row">
        <div class="col-1"></div>
        <div class="col-10">

            <div>
                <spatial-filter @click="select" button-text="Set selection">

                </spatial-filter>
                <br>
                <input :value="selectedSlug" name="entity_slug" type="hidden"></input>
                <input :value="selectedId" name="entity_id" type="hidden"></input>
            </div>

        </div>
        <div class="col-1"></div>
    </section>
</div>
        
</template>

<script>

import AdminUnitSpatialFilter from "../../filters/AdminUnitSpatialFilter";

export default {

    components: {
        "spatial-filter": AdminUnitSpatialFilter,
    },
    
    props: {
        defaultSelection: {
            type: Object,
            default: null,
        },

    },

    data() {

        return {

            selectedSlug: this.defaultSelection != null ? this.defaultSelection.slug : null,
            selectedId: this.defaultSelection != null ? this.defaultSelection.id : null,
            selectedCodePlusName: this.defaultSelection != null ? this.codePlusName(this.defaultSelection) : 'No admin unit',

        };

    },

    computed: {

    },

    mounted() {
        
    },

    methods: {

        clear()
        {
            this.selectedSlug = null;
            this.selectedId = null;
            this.selectedCodePlusName = 'No admin unit';
        },

        select(currentlySelected)
        {
            if(currentlySelected.name === 'Nation') {
                alert('Please select an administrative unit.');
                return;
            }

            this.selectedSlug = currentlySelected.slug;
            this.selectedId = currentlySelected.id;
            this.selectedCodePlusName = this.codePlusName(currentlySelected);
        },

        codePlusName(adminUnit)
        {
            return adminUnit.slug.charAt(0).toUpperCase() + adminUnit.slug.slice(1) + ' : ' + adminUnit.name + ', Code: ' + adminUnit.code;
        }


    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/administation/user/AdminUnitSelectComponent.vue